export const projectStatus = {
    INPUTS_REQUIRED: "inputs_required",
    ANALYSIS_READY_BAU: "analysis_ready_bau",
    ANALYSIS_READY_DER: "analysis_ready_der",
    ANALYSIS_COMPLETED: "analysis_completed",
    ANALYSIS_FAILED: "analysis_failed"
};
